import React, { FC, useEffect, useState } from 'react';
import { getLocalStorage, setLocalStorage } from '@/common/localStorages';
import { useGetCardDetail } from '@/queries/card';
import { Text } from '@mofid-securities/uikit';
import { RESTORE_FORM_OTP_TIMEOUT } from './constants';
import { useAPI } from '@/services/utils';
import { Divider } from '@/components/Divider';
import { FormSubmitButton } from '@/components/HookForm';
import OTPInputField from '@/components/OTPInputField';

const RestoreForm: FC = () => {
  const [timeout, setTimeout] = useState(RESTORE_FORM_OTP_TIMEOUT);
  const { mutateAsync: sendOTP, isLoading } = useAPI(
    ['card', 'sendRestoreOTP'],
    {
      isMutation: true,
    }
  );
  const { data } = useGetCardDetail();

  const handleOtpOnMountLogic = () => {
    const lastOtpSendTime = Number(getLocalStorage('lastRestoreOtpTime')) || 0;

    const currentDate = new Date().getTime();

    if (lastOtpSendTime) {
      // this calculates the amount of time that has been passed since the last otp send till now in seconds
      const lastOtpTillNow = (currentDate - lastOtpSendTime) / 1000;
      if (lastOtpTillNow >= RESTORE_FORM_OTP_TIMEOUT) {
        setLocalStorage('lastRestoreOtpTime', String(currentDate));
        sendOTP(null);
      } else {
        // if otp is already sent less that {RESTORE_FORM_OTP_TIMEOUT} seconds ago
        const remainingTime = RESTORE_FORM_OTP_TIMEOUT - lastOtpTillNow;
        setTimeout(remainingTime);
      }
    } else {
      setLocalStorage('lastRestoreOtpTime', String(currentDate));
      sendOTP(null);
    }
  };

  useEffect(() => {
    handleOtpOnMountLogic();
  }, []);

  return (
    <div className="flex h-full flex-col">
      <Text
        className="mb-2 text-mofidblue-filled-primary-enabled"
        size={'sm'}
        weight={'demibold'}
      >
        بازیابی مفید کارت
      </Text>
      <div className="mb-5 text-sm text-gray-filled-primary-enabled">
        لطفا برای فعال سازی مجدد مفید کارت، کد تایید ارسال شده به شماره{' '}
        {data?.mobile} را وارد کنید.
      </div>
      <OTPInputField
        classNames={{
          container: '!h-12',
          input:
            'tracking-[4px] placeholder:!text-center placeholder:!tracking-[4px]',
        }}
        isLoading={isLoading}
        name="code"
        placeholder="-------"
        timeout={timeout}
        isTimerOnEndAdornment
        onSendOTP={() => sendOTP(null)}
      />
      <Divider className="my-4" />
      <FormSubmitButton
        analytics={['MOFIDCARD_SESSION_EXPIRED_CONFIRM']}
        id="card_submit_sessionExpiredOTP"
        isSticky={false}
      >
        تایید
      </FormSubmitButton>
    </div>
  );
};

export default RestoreForm;
